import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { RouteComponentProps } from "react-router-dom";
import { Link } from "react-router-dom";
import aiLogo from "../../../../assets/images/ai-model-train.png";
import aiArrow from "../../../../assets/images/ai-model-train-aarow.png";
import sapcer from "../../../../assets/images/sapcer.png";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import { IProject, IApplicationState } from "../../../../models/applicationState";

export interface ISubHeaderProps extends RouteComponentProps, React.Props<ODSubHeader> {
    project: IProject;
    actions: IProjectActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
    };
}

export interface ISubHeaderState {
    subHeaderList: any[];
}

@connect(mapStateToProps)

export default class ODSubHeader
    extends React.Component<ISubHeaderProps, ISubHeaderState> {
    public state: ISubHeaderState = {
        subHeaderList: [
            { name: "Upload Files", path: "/upload-files/:projectName/:schema?/:type?/:projectId?", active: "", fontClass: "fa fa-upload bg-color-1" },
         
         
            //   { name: "Upload Files", path: "/upload-files/:projectName/:schema/:projectId?", active: "", fontClass: "fa fa-upload bg-color-1" },
          //  { name: " Annotate", path: "/projects/:projectName/:projectId/edit/:schema?", active: "", fontClass: "ann-ico" },
          //  { name: " AnnotateFR", path: "/projectsFR/:projectName/:projectId/edit/:schema?", active: "", fontClass: "ann-ico" },
        // //${urlPath}/${schemaParam}`);
          { name: " Annotate", path: "/ODProjects/:projectName/:projectId/:type?/edit/:schema?", active: "", fontClass: "ann-ico" },  
          { name: " Analysis", path: "/ODProjects/:projectName/:projectId/:type?/analysis", active: "", fontClass: "analysis-ico" },
           // { name: " Test", path: "/projects/:projectName/:projectId/:schema?/test", active: "", fontClass: "fa fa-check bg-color-1" },
            { name: " Test AI Models", path: "/ODProjects/:projectName/:projectId/:type?/test-files/:schema?", active: "", fontClass: "fa fa-check bg-color-1" },
            //{ name: " Test", path: "/projects/:projectName/:projectId//:schema?/test-files", active: "", fontClass: "fa fa-check bg-color-1" },
            { name: " Advanced Features", path: "/ODprojects/:projectName/:projectId/advanced-features", active: "", fontClass: "fa fa-cog bg-color-1" },
        ]
    }

    public returnUrlPath = (path, headerName, project) => {
        
        let routePath = "";
        switch (headerName.name) {
            case "Upload Files":
                const projectId = path.params.projectId ? `${path.params.projectId}` : "";
              //  routePath = `/OCR-upload-files/${path.params.projectName}/${path.params.schema ? path.params.schema : "na"}${projectId}`;
              routePath = `/upload-files/${path.params.projectName}/${path.params.schema ? path.params.schema : "na"}/${path.params.type ? path.params.type : "na"}/${projectId}`;  
            
                        
              break;
          
                case " Annotate":
                 
                    routePath = `/ODProjects/${path.params.projectName}/${path.params.projectId}/od/edit/${path.params.schema ? path.params.schema : "na"}`;
                   
                    break;
               
            case " Analysis":
               // routePath = `/projects/${path.params.projectName}/${path.params.projectId}/analysis`;
                
                routePath = `/ODProjects/${path.params.projectName}/${path.params.projectId}/od/analysis`;
               
                break;
             

                case " Test AI Models":
                    routePath = `/ODProjects/${path.params.projectName}/${path.params.projectId}/od/test-files/${path.params.schema ? path.params.schema : "na"}`;
                    break;
 

           /* case " Test":
                debugger;
                const parts = path.url.split("/");
                let urlList;
                const lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
                if (path !== "test" || path === "test") {
                    urlList = "test";
                }
                if (lastSegment === "test-files") {
                    urlList = "test-files";
                }
                routePath = `/projects/${path.params.projectName}/${path.params.projectId}/na/${urlList}`;
                break;
                */
            case " Advanced Features":
                routePath = `/ODProjects/${path.params.projectName}/${path.params.projectId}/advanced-features`;
                break;
            default:
                routePath = `/dashboard`;
        }
        return routePath;
    };

    public render() {
      //  debugger;
        return (
            <nav className="navbar navbar-expand-md bg-dark navbar-dark sub-nav">
                <ul className="navbar-nav nav">
                    <li className="text-right select-model-2">
                        <span className="text-uppercase"> {this.props.match.params["projectName"]} </span>
                    </li>
                    <li className="text-right">
                        <span className="nav-title">AI MODEL TRAIN </span>
                        <img src={aiArrow} />
                    </li>
                    {this.state.subHeaderList && this.state.subHeaderList.map((header, index) => {
                        header.active = header.path === this.props.match.path ? "active" : "";
                        if (header.name === " Test" && this.props.match.path === "/projects/:projectName/:projectId/:type?/:schema?/test") {
                            header.active = "active";
                        } 

                        /*
                        else if (header.name === " Test" && this.props.match.path === "/projectsFR/:projectName/:projectId/:schema?/test-files") {
                            header.active = "active";
                        }
                        else
                        */
                       

                        let routeUrl = "";
                        let pointerClass = "pointer-events";
                        const analysisData = localStorage.getItem("trainResult") && localStorage.getItem("trainResult");
                        // if (this.props.match.path && this.props.match.params["projectId"] && analysisData === "true") {
                        //     routeUrl = this.returnUrlPath(this.props.match, header, this.props.project);
                        //     pointerClass = "";
                        // }

                        if ((header.name === " Annotate") &&((this.props.match.path === "/ODProjects/:projectName/:projectId/:type?/edit/:schema?")  ||(this.props.match.path === "/OCRProjects/:projectName/:projectId/:type?/edit/:schema?") ))
                        {
                            pointerClass = "";
                            header.active = "active";
                        }

                        if ((header.name === " Analysis") &&(this.props.match.path === "/ODProjects/:projectName/:projectId/od/analysis") )
                        {
                            pointerClass = "";
                            header.active = "active";
                        }

                        
                        if ((header.name === " Test AI Models") &&(this.props.match.path === "/ODProjects/:projectName/:projectId/od/test-files/:schema?") )
                        {
                            pointerClass = "";
                            header.active = "active";
                        }
                        /*
                        if (this.props.project && index === 0 && header.name === "Upload Files") {
                            routeUrl = this.returnUrlPath(this.props.match, header, this.props.project);
                            pointerClass = "";
                        }*/
                       if (analysisData === "true") {
                            routeUrl = this.returnUrlPath(this.props.match, header, this.props.project);
                            pointerClass = "";
                            
                        }

                           if ((header.name === "Upload Files") &&(this.props.match.path === "/upload-files/:projectName/:schema?/:type?/:projectId?") )
                        {
                            pointerClass = "";
                            header.active = "active";
                        }

                        if(this.props.project && index === 0 && header.name === "TestFiles")
                        {
                            routeUrl = this.returnUrlPath(this.props.match, header, this.props.project);
                            pointerClass = "";
                            header.active = "active";
                        }



                        return (
                            <li key={index} className="nav-item ">
                                <Link className={`nav-link ${header.active} ${pointerClass}`}
                                    to={routeUrl}>
                                    <i className={`${header.fontClass}`} aria-hidden="true">
                                        {index && (index === 1 || index === 2) && <img src={sapcer} />}
                                    </i>
                                    <span className="">{header.name}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        );
    }
}

